import DesignAPIs from '@/API/design/design-api'

export default {
  namespaced: true,

  state: {
    iPadThemes: [],
    mobileThemes: [],
    themes: {},
    themesFetched: false,
    showQrActiveTooltip: false,
    showTabletActiveTooltip: false,
  },

  getters: {
    currentMobileThemes: (state: any) => state.mobileThemes,
    currentIpadThemes: (state: any) => state.iPadThemes,
    activeMobileTheme: (state: any, getters: any, rootState: any, rootGetters: any) => {
      const activeMobileThemeId = rootGetters['auth/mobileThemeId']
      return state.mobileThemes.find((theme: any) => theme.id === activeMobileThemeId)
    },
    activeIpadTheme: (state: any, getters: any, rootState: any, rootGetters: any) => {
      const activeIpadThemeId = rootGetters['auth/ipadThemeId']
      return state.iPadThemes.find((theme: any) => theme.id === activeIpadThemeId)
    },
    activeCategoryLayoutTheme: (state: any) => state.iPadThemes.find((theme: any) => theme.active)?.categories_layout,
    activeItemsLayoutTheme: (state: any, getters: any, rootState: any, rootGetters: any) => {
      const activeIpadThemeId = rootGetters['auth/ipadThemeId']
      return state.iPadThemes.find((theme: any) => theme.id === activeIpadThemeId)?.items_layout
    },
    showQrActiveTooltip: (state: any) => state.showQrActiveTooltip,
    showTabletActiveTooltip: (state: any) => state.showTabletActiveTooltip,
  },

  mutations: {
    SET_IPAD_THEMES(state: any, themes: Array<any>) {
      state.iPadThemes = themes
    },
    SET_Mobile_THEMES(state: any, themes: Array<any>) {
      state.mobileThemes = themes
    },
    SET_THEMES(state: any, options: any) {
      const { branchId, mobile, ipad } = options
      state.themes[branchId] = { mobile, ipad }
      state.themesFetched = true
    },
    CLEAR_CACHED_THEMES(state: any) {
      state.themes = {}
      state.themesFetched = false
    },
    SET_SHOW_QR_ACTIVE_TOOLTIP(state: any, show = true) {
      state.showQrActiveTooltip = show
    },
    SET_SHOW_TABLET_ACTIVE_TOOLTIP(state: any, show = true) {
      state.showTabletActiveTooltip = show
    },
  },

  actions: {
    RESET(context: any) {
      context.commit('CLEAR_CACHED_THEMES')
    },
    async FETCH_THEMES(context: any, force: false) {
      if (context.state.themesFetched && !force) return context.state.themes

      const branchId = context.rootGetters['branches/currentBranchId']
      const { mobile, ipad } = await context.dispatch('FETCH_BRANCH_THEMES', branchId)
      context.commit('SET_IPAD_THEMES', ipad)
      context.commit('SET_Mobile_THEMES', mobile)
      return { mobile, ipad }
    },
    async FETCH_BRANCH_THEMES(context: any, payload: any) {
      let branchId: any = null
      let force = true
      if (typeof payload === 'number') {
        branchId = payload
      } else {
        branchId = payload.branchId
        force = payload.force ?? false
      }
      if (context.state.themes[branchId] && !force) {
        return context.state.themes[branchId]
      }
      const { mobile, ipad } = await DesignAPIs.getThemesList()
      context.commit('SET_THEMES', { branchId, mobile, ipad })
      return { mobile, ipad }
    },
    async GET_ACTIVE_ITEMS_LAYOUT_THEME(context: any, branchId: number) {
      const { ipad } = await context.dispatch('FETCH_BRANCH_THEMES', branchId)
      const theme = ipad.find((_theme: any) => _theme.active)
      if (!theme) {
        throw Error(`There is no active theme in this branch (${branchId})`)
      }
      const itemsLayout = theme.items_layout
      const categoriesLayout = theme.categories_layout
      return {
        ...categoriesLayout,
        items_layout: itemsLayout?.layout_type ?? itemsLayout?.items_layout ?? 0,
      }
    },
    async GET_ACTIVE_QR_THEME(context: any, payload: number) {
      const { mobile } = await context.dispatch('FETCH_BRANCH_THEMES', payload)
      const theme = mobile.find((_theme: any) => _theme.active)
      if (!theme) {
        throw Error('There is no active theme in this branch')
      }
      return theme
    },
  },
}
